import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ArticlesMapComponent } from '../articles-map/articles-map.component';
import { GoogleCharts } from 'google-charts';

@Component({
  selector: 'app-dialog-map',
  templateUrl: './dialog-map.component.html',
  styleUrls: ['./dialog-map.component.less']
})
export class DialogMapComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ArticlesMapComponent>, @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
    this.drawMap();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  drawMap() {
    GoogleCharts.load(() => {
      const countries = GoogleCharts.api.visualization.arrayToDataTable(this.data);
      const countriesOptions = {
      colorAxis: {
        colors: ['#fce3d0', '#ff9800']
      },
      chartArea: {
        width: '80%',
        height: '50%'
      }
    };
      const countriesChart = new GoogleCharts.api.visualization.GeoChart(document.getElementById('map'));
      countriesChart.draw(countries, countriesOptions);
    });
  }


}
